import { render } from "./EmailDiffControls.vue?vue&type=template&id=3722d587"
import script from "./EmailDiffControls.vue?vue&type=script&lang=js"
export * from "./EmailDiffControls.vue?vue&type=script&lang=js"
script.render = render

export default script